import styled from "@emotion/styled";
export const StyledAshbyApplicationForm = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0;

  @media (max-width: 768px) {
    padding: 0 16px;
  }


  .form-section {
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #323338;
    margin-bottom: 8px;
  }

  .section-description {
    font-size: 0.875rem;
    color: #676879;
    margin-bottom: 12px;
  }

  .section-divider {
    border: none;
    height: 2px;
    background: linear-gradient(90deg, #e1e4e9 0%, #f1f3f5 50%, #e1e4e9 100%);
    margin: 40px 0;
    border-radius: 1px;
  }

  .form-field {
    margin-bottom: 16px;

    label {
      display: block;
      font-size: 0.875rem;
      font-weight: 500;
      color: #323338;
      margin-bottom: 4px;

      &.required::after {
        content: " *";
        color: #e44258;
      }
    }

    .field-description {
      display: block;
      font-size: 0.75rem;
      color: #676879;
      margin-bottom: 4px;
    }

    .error-text {
      display: block;
      font-size: 0.75rem;
      color: #e44258;
      margin-top: 4px;
    }
  }

  .ashby-input,
  .ashby-select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #c5c7d0;
    border-radius: 8px;
    font-size: 0.875rem;
    color: #323338;
    background: #ffffff;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: #009aff;
    }

    &.has-error {
      border-color: #e44258;
    }
  }

  .ashby-textarea {
    resize: vertical;
    min-height: 80px;
  }

  .ashby-checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .ashby-file-input {
    font-size: 0.875rem;
    color: #323338;

    &.has-error {
      color: #e44258;
    }
  }

  .submit-button {
    width: 100%;
    padding: 14px;
    background: #009aff;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 24px;
    transition: background 0.2s;

    &:hover {
      background: #0086e0;
    }

    &:disabled {
      background: #c5c7d0;
      cursor: not-allowed;
    }
  }

  .submit-error {
    color: #e44258;
    font-size: 0.875rem;
    margin-bottom: 10px;
    text-align: center;
  }

  .success-message {
    text-align: center;
    padding: 40px 20px;

    h3 {
      font-size: 1.5rem;
      font-weight: bold;
      color: #323338;
      margin-bottom: 12px;
    }

    p {
      font-size: 1rem;
      color: #676879;
    }
  }

  /* Resume Autofill Styles */
  .autofill-section {
    background: #f8f9fc;
    border: 2px dashed #d6dae5;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    text-align: center;
  }

  .autofill-header {
    h4 {
      color: #323338;
      font-size: 1.125rem;
      font-weight: 600;
      margin-bottom: 8px;
    }

    p {
      color: #676879;
      font-size: 0.875rem;
      margin-bottom: 20px;
    }

  }

  .autofill-upload-button {
    display: inline-block;
    background: #009aff;
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    font-size: 1rem;

    &:hover {
      background: #0085d1;
      transform: translateY(-1px);
    }

    &.loading {
      background: #676879;
      cursor: not-allowed;
      transform: none;
    }
  }

  .autofill-status {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .status-success {
      color: #00ca72;
      font-weight: 500;
      font-size: 0.875rem;
    }

    .status-partial {
      color: #009aff;
      font-weight: 500;
      font-size: 0.875rem;
    }

    .status-error {
      color: #676879;
      font-weight: 500;
      font-size: 0.875rem;
    }

    .file-name {
      color: #676879;
      font-size: 0.8125rem;
      background: white;
      padding: 8px 12px;
      border-radius: 6px;
      border: 1px solid #d6dae5;
    }
  }


  .privacy-divider {
    border: none;
    border-top: 1px solid #e1e4e9;
    margin: 24px 0 16px;
  }

  .privacy-notice {
    font-size: 0.875rem;
    color: #323338;
    margin-bottom: 16px;

    a {
      color: #323338;
      text-decoration: underline;

      &:hover {
        color: #009aff;
      }
    }
  }

  /* Resume Field Populated Styles */
  .resume-field-populated {
    .resume-file-status {
      display: flex;
      align-items: center;
      gap: 12px;
      background: #f0f3ff;
      border: 1px solid #009aff;
      border-radius: 8px;
      padding: 12px 16px;

      .file-icon {
        font-size: 1.125rem;
      }

      .file-name {
        flex: 1;
        color: #323338;
        font-weight: 500;
        font-size: 0.875rem;
      }

      .change-file-button {
        background: #009aff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 0.8125rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s ease;

        &:hover {
          background: #0085d1;
        }
      }
    }
  }
`;
